import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/contact/refused-confirmations",
    component: MainPage,
    exact: false,
    name: "Citas Médicas - Regulares Canceladas"
  }
];

export default routes;
